import { IAccountOrganizationDTO, IAccountOrganizationsDAO, ICreateAccountOrganizationDTO } from '../account-organizations.dao';
import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import {
    ACCOUNT_ORGANIZATIONS_LIST_URL,
    CREATE_ACCOUNT_ORGANIZATION_URL
} from '../../constants/api/account-organizations-api.constants';

export class AccountOrganizationsDAO extends IAccountOrganizationsDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAccountOrganizations(accountId: number): Promise<IAccountOrganizationDTO[]> {
        const response = await this.apiClient.get<IAccountOrganizationDTO[]>(ACCOUNT_ORGANIZATIONS_LIST_URL, {
            accountId: accountId
        });
        return response.parsedResponse;
    }

    public async createAccountOrganization(accountId: number, params: ICreateAccountOrganizationDTO): Promise<IAccountOrganizationDTO> {
        const response = await this.apiClient.post<IAccountOrganizationDTO>(CREATE_ACCOUNT_ORGANIZATION_URL, {
            accountId: accountId,
            ...params
        });
        return response.parsedResponse;
    }
}
